<div class="card">
    <div class="card-body">
        <h5 class="card-title">{{ 'export.bim.cardTitle' | transloco }}</h5>
        <h6 class="card-subtitle mb-2 text-muted">{{ 'export.selectExportTypeBelow' | transloco }}</h6>
        <hr />
        <button class="btn btn-default me-2 mb-2" (click)="moiExport()">{{ 'export.bim.moisButton' | transloco }}</button>
        <button class="btn btn-default me-2 mb-2" (click)="moiSummaryExport()">{{ 'export.bim.moiSummaryButton' | transloco }}</button>
        @if (isBimAdmin) {
            <button class="btn btn-default me-2 mb-2" (click)="moiCommentsExport()">
                {{ 'export.bim.moisAndCommentsButton' | transloco }}
            </button>
        }
        <button class="btn btn-default me-2 mb-2" (click)="findingReportAssessmentExport()">
            {{ 'export.bim.findingReportsAssessmentsButton' | transloco }}
        </button>
        <button class="btn btn-default me-2 mb-2" (click)="findingReportInformationExport()">
            {{ 'export.bim.findingReportInformationButton' | transloco }}
        </button>
    </div>
</div>
